import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export type IconName = keyof typeof PATHS;

export interface GlyphProps {
    name: IconName;
    size?: number;
    strokeWidth?: number;
    className?: string;
}

/** Логотип сервиса «Предиктивная аналитика». */
export const BrandMarkIcon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 44 44" aria-hidden="true" {...props}>
        <defs>
            <linearGradient id="logoGrad" x1="0" y1="1" x2="1" y2="0">
                <stop stopColor="#8fc7ea" />
                <stop offset="1" stopColor="#ffffff" />
            </linearGradient>
        </defs>
        <path
            d="M22 3.5 38 12.7v18.6L22 40.5 6 31.3V12.7Z"
            fill="rgba(255,255,255,.08)"
            stroke="rgba(255,255,255,.32)"
        />
        <path
            d="M11.5 27.5c4.7-.7 6.8-3.7 9.8-7.2 3.1-3.7 5.6-5.2 11.2-6.1"
            fill="none"
            stroke="url(#logoGrad)"
            strokeWidth="2.6"
            strokeLinecap="round"
        />
        <circle cx="12" cy="27.4" r="2.2" fill="#9ed0ee" />
        <circle cx="21.2" cy="20.4" r="2.2" fill="#c9e5f6" />
        <circle cx="32.1" cy="14.3" r="2.2" fill="#fff" />
        <path
            d="M27 31.5h6M30 28.5v6"
            stroke="rgba(255,255,255,.5)"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
    </svg>
);

/** Знак департамента государственного заказа ЯНАО. */
export const DepartmentMarkIcon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 42 45" aria-hidden="true" {...props}>
        <path
            d="M8.27596 40.1644C8.33961 37.9685 10.1854 36.2818 12.3495 36.3455C14.5454 36.4091 16.2321 38.255 16.1684 40.419C16.1048 42.6149 14.259 44.3016 12.0949 44.238C9.93083 44.1743 8.21231 42.3285 8.27596 40.1644Z"
            fill="white"
        />
        <path
            d="M7.12132 34.7864L16.064 25.8438L30.6396 40.3557L25.9932 45.0021L17.0505 36.0912C14.9183 33.959 12.2769 33.7362 9.50816 34.1181C8.99896 34.1818 8.42612 34.2772 7.12132 34.7864Z"
            fill="white"
        />
        <path
            d="M30.4844 4.83308C30.4207 7.02897 28.5749 8.71567 26.4108 8.65202C24.2149 8.58837 22.5282 6.74255 22.5919 4.57849C22.6555 2.3826 24.5014 0.695907 26.6654 0.759556C28.8295 0.823205 30.548 2.6372 30.4844 4.83308Z"
            fill="white"
        />
        <path
            d="M33.5428 29.3182L32.3017 28.0771C31.2196 26.9951 31.2196 25.2129 32.3017 24.1309L38.7939 17.6068V9.52344L25.9686 22.3805C24.8866 23.4625 24.8866 25.2447 25.9686 26.3267L31.2833 31.5778L29.0556 33.7737L33.0973 37.8154L38.7939 32.1506V24.0672L33.5428 29.3182Z"
            fill="white"
        />
        <path
            d="M7.54282 13.3359L9.92965 10.9491L5.8243 6.84375L0.000427246 12.6358V20.8147L5.21963 15.5955L6.46079 16.8366C7.54282 17.9187 7.54282 19.7008 6.46079 20.7828L0.0322512 27.3387V35.4221L12.8575 22.565C13.9395 21.483 13.9395 19.7008 12.8575 18.6188L7.54282 13.3359Z"
            fill="white"
        />
        <path
            d="M31.6047 10.2156L22.662 19.1583L8.08641 4.64636L12.7328 0L21.6754 8.91084C23.7759 10.884 26.4491 11.2658 29.2178 10.884C29.7589 10.8203 30.3317 10.693 31.6047 10.2156Z"
            fill="white"
        />
    </svg>
);

/** Линейный график динамики цен на левой панели. */
export const TrendChartIcon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 470 54" preserveAspectRatio="none" aria-hidden="true" {...props}>
        <path className="chartGrid" d="M0 13H470 M0 34H470 M0 53H470" />
        <path
            className="chartLine"
            d="M0 47 C35 44 51 34 77 36 C115 39 127 26 166 28 C207 31 225 18 259 20 C304 23 326 11 362 14 C404 17 428 8 470 5"
        />
    </svg>
);

export const PhoneIcon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
        <path d="M7 4h3l1.5 4-2 1.5a14 14 0 0 0 5 5L16 12.5l4 1.5v3c0 1.1-.9 2-2 2C10.8 19 5 13.2 5 6c0-1.1.9-2 2-2z" />
    </svg>
);

export const MailIcon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
        <path d="M4 6h16v12H4z" />
        <path d="m4 7 8 6 8-6" />
    </svg>
);

export const LockIcon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
        <rect x="5" y="10" width="14" height="10" rx="2" />
        <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </svg>
);

export const CrossIcon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
        <path d="m7 7 10 10M17 7 7 17" />
    </svg>
);

export const EyeIcon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
        <path d="M3 12s3.3-5 9-5 9 5 9 5-3.3 5-9 5-9-5-9-5z" />
        <circle cx="12" cy="12" r="2.5" />
    </svg>
);

export const EyeOffIcon: FC<IconProps> = (props) => (
    <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="M3 12s3.3-5 9-5 9 5 9 5-3.3 5-9 5-9-5-9-5z" />
        <circle cx="12" cy="12" r="2.5" fill="currentColor" stroke="none" />
        <line x1="20" y1="4" x2="4" y2="20" />
    </svg>
);

export const CheckIcon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 16 16" aria-hidden="true" {...props}>
        <path d="m3.5 8.2 2.7 2.7 6.1-6.1" />
    </svg>
);

const base = {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.75,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': true,
    focusable: false,
} as const;

/* ─── Навигация и раскрытие ─────────────────────────────── */

export const ChevronRightIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="m9 6 6 6-6 6" />
    </svg>
);

export const ChevronDownIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="m6 9 6 6 6-6" />
    </svg>
);

export const ChevronLeftIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="m15 6-6 6 6 6" />
    </svg>
);

export const CloseIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M18 6 6 18M6 6l12 12" />
    </svg>
);

/* ─── Топбар ────────────────────────────────────────────── */

export const SearchIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.5-3.5" />
    </svg>
);

export const BellIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M18 8.5a6 6 0 1 0-12 0c0 5-2 6.5-2 6.5h16s-2-1.5-2-6.5Z" />
        <path d="M13.7 18.5a2 2 0 0 1-3.4 0" />
    </svg>
);

export const GearIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 14.5a1.6 1.6 0 0 0 .32 1.77l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.6 1.6 0 0 0-1.77-.32 1.6 1.6 0 0 0-.97 1.47V21a2 2 0 1 1-4 0v-.1a1.6 1.6 0 0 0-1.05-1.46 1.6 1.6 0 0 0-1.77.32l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.6 1.6 0 0 0 .32-1.77 1.6 1.6 0 0 0-1.47-.97H3a2 2 0 1 1 0-4h.1a1.6 1.6 0 0 0 1.46-1.05 1.6 1.6 0 0 0-.32-1.77l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.6 1.6 0 0 0 1.77.32H9a1.6 1.6 0 0 0 .97-1.47V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 .97 1.47 1.6 1.6 0 0 0 1.77-.32l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.6 1.6 0 0 0-.32 1.77V9a1.6 1.6 0 0 0 1.47.97H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.47.97Z" />
    </svg>
);

export const LogoutIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M9 21H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3" />
        <path d="m15.5 16.5 4.5-4.5-4.5-4.5" />
        <path d="M20 12H9" />
    </svg>
);

export const OrgIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M3 21h18" />
        <path d="M5 21V6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v15" />
        <path d="M13 21V11a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10" />
        <path d="M8 9h2M8 13h2M8 17h2M16 14h.01M16 18h.01" />
    </svg>
);

export const DatabaseIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <ellipse cx="12" cy="5.5" rx="8" ry="3" />
        <path d="M4 5.5v13c0 1.66 3.58 3 8 3s8-1.34 8-3v-13" />
        <path d="M4 12c0 1.66 3.58 3 8 3s8-1.34 8-3" />
    </svg>
);

export const UserIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <circle cx="12" cy="8" r="4" />
        <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
    </svg>
);

/* ─── Карточки ресурсов ─────────────────────────────────── */

export const DownloadIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M12 3v12" />
        <path d="m7.5 10.5 4.5 4.5 4.5-4.5" />
        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
    </svg>
);

export const ExternalLinkIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M14 4h6v6" />
        <path d="M20 4 11 13" />
        <path d="M18 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5" />
    </svg>
);

export const PlayIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M8 5.5v13l11-6.5-11-6.5Z" />
    </svg>
);

export const QrIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
        <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
        <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
        <path d="M14 14h2.5v2.5H14zM19 14h1.5M19 19h1.5M14 19h2.5v1.5" />
    </svg>
);

/* ─── Поддержка ─────────────────────────────────────────── */

export const ChatIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M20 12.5c0 3.87-3.58 7-8 7a9.4 9.4 0 0 1-2.9-.45L4 20.5l1.35-4.02A6.6 6.6 0 0 1 4 12.5c0-3.87 3.58-7 8-7s8 3.13 8 7Z" />
        <path d="M9 12h.01M12 12h.01M15 12h.01" />
    </svg>
);

export const QuestionIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <circle cx="12" cy="12" r="9" />
        <path d="M9.6 9.4a2.5 2.5 0 1 1 3.4 2.35c-.62.24-1 .84-1 1.5v.5" />
        <path d="M12 17h.01" />
    </svg>
);

/* ─── Разделы сайдбара ──────────────────────────────────── */

export const HomeIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="m3.5 10.5 8.5-7 8.5 7" />
        <path d="M5.5 9v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9" />
        <path d="M10 20v-6h4v6" />
    </svg>
);

export const ProjectsIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M3 7a2 2 0 0 1 2-2h3.6a2 2 0 0 1 1.6.8l1 1.2H19a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
    </svg>
);

export const DocumentIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" />
        <path d="M14 3v5h5" />
        <path d="M9 13h6M9 17h4" />
    </svg>
);

export const SuppliersIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M3 8.5 12 4l9 4.5-9 4.5-9-4.5Z" />
        <path d="m3 13 9 4.5L21 13" />
        <path d="m3 17.5 9 4.5 9-4.5" />
    </svg>
);

export const ReportsIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M4 20V4" />
        <path d="M4 20h16" />
        <path d="M8 20v-6M12.5 20V8M17 20v-9" />
    </svg>
);

export const UsersIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <circle cx="9.5" cy="8" r="3.5" />
        <path d="M3.5 19.5a6 6 0 0 1 12 0" />
        <path d="M16 5.2a3.5 3.5 0 0 1 0 5.6" />
        <path d="M17.5 14.4a6 6 0 0 1 3 5.1" />
    </svg>
);

/** Все иконки наследуют размер и цвет от родителя: fill/stroke задаются в стилях. */
const Base = ({ children, ...props }: IconProps) => (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
        {children}
    </svg>
);

export const PlusIcon = (props: IconProps) => (
    <Base {...props}>
        <path d="M12 6v12M6 12h12" />
    </Base>
);


export const TrashIcon = (props: IconProps) => (
    <Base {...props}>
        <path d="M6 7h12M9 7V5h6v2M8 7l1 12h6l1-12" />
    </Base>
);

/** Заглушка вместо картинки товара, когда изображение не пришло. */
export const IconPicture: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="m21 15-5-5L5 21" />
    </svg>
);

/** Булавка на карте — для подписи региона поиска. */
export const IconPin: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
    </svg>
);

/** Корзина со скруглёнными штрихами — для удаления в строке таблицы. */
export const TrashBinIcon: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M3 6h18" />
        <path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
        <path d="M19 6l-.8 13.1a2 2 0 0 1-2 1.9H7.8a2 2 0 0 1-2-1.9L5 6" />
        <path d="M10 11v6M14 11v6" />
    </svg>
);

export const EditIcon = (props: IconProps) => (
    <Base {...props}>
        <path d="M5 19h3l9-9-3-3-9 9zM14.5 6.5l3 3" />
    </Base>
);

export const CopyIcon = (props: IconProps) => (
    <Base {...props}>
        <rect x="9" y="9" width="9" height="11" rx="2" />
        <path d="M15 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3" />
    </Base>
);

export const CaretUpIcon = (props: IconProps) => (
    <Base {...props}>
        <path d="m6 14 6-6 6 6" />
    </Base>
);

export const WarningIcon = (props: IconProps) => (
    <Base {...props}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 8v5M12 16h.01" />
    </Base>
);

export const DocPlusIcon = (props: IconProps) => (
    <Base {...props}>
        <path d="M5 4.5h9l5 5V20H5z" />
        <path d="M14 4.5v5h5M12 12v5M9.5 14.5h5" />
    </Base>
);

export const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
        <rect x="4.5" y="5.5" width="15" height="14" rx="2" />
        <path d="M8 3.5v4M16 3.5v4M4.5 10h15" />
    </svg>
);

export const IconHome: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M4 12 12 5l8 7v7a1 1 0 0 1-1 1h-5v-6h-4v6H5a1 1 0 0 1-1-1z" />
    </svg>
);

export const IconProjects: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M5 4.5h9l5 5V20H5z" />
        <path d="M14 4.5v5h5M8 13h8M8 16.5h5" />
    </svg>
);

export const IconChat: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M5 5h14v11H9l-4 3z" />
        <path d="M9 9h6M9 12h4" />
    </svg>
);

export const IconSuppliers: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M4 19h16M6 19V9l6-4 6 4v10" />
        <path d="M9 12h6M9 15h4" />
    </svg>
);

export const IconAdmin: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M4 20h16V8H4zM8 8V4h8v4" />
        <path d="M9 13h6M9 16h4" />
    </svg>
);

export const IconSupport: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M5 12a7 7 0 0 1 14 0v5h-4v-5h4M5 12v5h4v-5z" />
        <path d="M15 19h-3" />
    </svg>
);

export const IconNews: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M5 6h14v13H5z" />
        <path d="M8 3v6M16 3v6M8 12h8M8 15.5h5" />
    </svg>
);

export const IconFaq: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <circle cx="12" cy="12" r="8" />
        <path d="M10 9.5a2.2 2.2 0 1 1 3.1 2c-.8.5-1.1.9-1.1 2M12 16.5h.01" />
    </svg>
);

/* ─── управление ────────────────────────────────────────────── */

export const IconChevronDown: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="m7 10 5 5 5-5" />
    </svg>
);

export const IconChevronUp: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="m6 14 6-6 6 6" />
    </svg>
);

export const IconChevronDownBold: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="m6 10 6 6 6-6" />
    </svg>
);

export const IconArrowLeft: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M15 6l-6 6 6 6" />
    </svg>
);

export const IconClose: FC<IconProps> = (props) => (
    <svg {...base} {...props}
        viewBox="0 0 20 20"
        width="15"
        height="15"
        aria-hidden="true"
    >
        <path
            d="M5 5l10 10M15 5L5 15"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
        />
    </svg>
);

export const IconPlus: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M12 6v12M6 12h12" />
    </svg>
);

export const IconCheck: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="m5 12 5 5 9-10" />
    </svg>
);

export const IconSearch: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <circle cx="11" cy="11" r="6.5" />
        <path d="m16 16 4 4" />
    </svg>
);

export const IconRefresh: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M5 12a7 7 0 1 1 2 5" />
        <path d="M5 17v-5h5" />
    </svg>
);

export const IconDownload: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M12 4v10M8.5 10.5 12 14l3.5-3.5M5 19h14" />
    </svg>
);

export const IconCamera: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M4 8.5A1.5 1.5 0 0 1 5.5 7H8l1.2-2h5.6L16 7h2.5A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5v-9Z" />
        <circle cx="12" cy="13" r="3.2" />
    </svg>
);

export const IconTable: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M3 9h18M9 21V9" />
    </svg>
);

export const IconUpload: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M12 20V9M8.5 12.5 12 9l3.5 3.5M5 5h14" />
    </svg>
);

export const IconCloudUpload: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M7 17.5A3.5 3.5 0 0 1 7.3 10.6a5 5 0 0 1 9.6-1.1A3.75 3.75 0 0 1 17.5 17" />
        <path d="M12 20v-7M9.2 15.3 12 12.5l2.8 2.8" />
    </svg>
);

export const IconSpinner: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M12 4a8 8 0 1 1-8 8" />
    </svg>
);

export const IconExternal: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M7 17 17 7M10 7h7v7" />
    </svg>
);

export const IconSwap: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M4 8.5h11M20 15.5H9" />
        <path d="m11.5 5.5 3.5 3-3.5 3M12.5 12.5 9 15.5l3.5 3" />
    </svg>
);

export const IconWarning: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M12 8v5M12 16h.01" />
        <circle cx="12" cy="12" r="8.5" />
    </svg>
);

/* ─── предметные ────────────────────────────────────────────── */

export const IconBell: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M6 16h12l-1-2V9a5 5 0 0 0-10 0v5zM10 19h4" />
    </svg>
);

export const IconDatabase: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <ellipse cx="12" cy="5.5" rx="7" ry="3" />
        <path d="M5 5.5v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6M5 11.5v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" />
    </svg>
);

export const IconSettings: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
        <path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.4 1A8 8 0 0 0 15 6l-.3-2.6h-4L10.4 6A8 8 0 0 0 8.8 7L6.4 6 4.5 9.5 6.5 11a7 7 0 0 0 0 2l-2 1.5L6.4 18l2.4-1A8 8 0 0 0 10.4 18l.3 2.6h4L15 18a8 8 0 0 0 1.6-1l2.4 1 2-3.5-2-1.5a7 7 0 0 0 0-1z" />
    </svg>
);

export const IconLogout: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M10 5H5v14h5M14 8l4 4-4 4M18 12H9" />
    </svg>
);

export const IconTruck: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M3 16V8h11v8zM14 11h4l3 3v2h-7z" />
        <circle cx="7.5" cy="17.5" r="1.7" />
        <circle cx="17.5" cy="17.5" r="1.7" />
    </svg>
);

export const IconRuble: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <circle cx="12" cy="12" r="8" />
        <path d="M14 9.5a2.6 2.6 0 0 0-4 .6c0 2 4 1.8 4 3.8a2.6 2.6 0 0 1-4 .6M12 7.5v9" />
    </svg>
);

export const IconSheet: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M4 5h16v14H4z" />
        <path d="M4 10h16M10 10v9" />
    </svg>
);

/* ─── логотип сервиса ───────────────────────────────────────── */

export const BrandMark: FC<IconProps> = (props) => (
    <svg viewBox="0 0 44 44" aria-label="Логотип сервиса" {...props}>
        <defs>
            <linearGradient id="brandMarkGradient" x1="0" x2="1" y1="1" y2="0">
                <stop stopColor="#8fc7ea" />
                <stop offset="1" stopColor="#fff" />
            </linearGradient>
        </defs>
        <path
            d="M22 3.5 38 12.7v18.6L22 40.5 6 31.3V12.7Z"
            fill="rgba(255,255,255,.08)"
            stroke="rgba(255,255,255,.32)"
        />
        <path
            d="M11.5 27.5c4.7-.7 6.8-3.7 9.8-7.2 3.1-3.7 5.6-5.2 11.2-6.1"
            fill="none"
            stroke="url(#brandMarkGradient)"
            strokeLinecap="round"
            strokeWidth="2.6"
        />
        <circle cx="12" cy="27.4" fill="#9ed0ee" r="2.2" />
        <circle cx="21.2" cy="20.4" fill="#c9e5f6" r="2.2" />
        <circle cx="32.1" cy="14.3" fill="#fff" r="2.2" />
        <path d="M27 31.5h6M30 28.5v6" stroke="rgba(255,255,255,.5)" strokeLinecap="round" strokeWidth="1.2" />
    </svg>
);

/* ─── логотипы маркетплейсов ────────────────────────────────── */

export const MarketLogoOzon: FC<IconProps> = (props) => (
    <svg viewBox="0 0 48 48" aria-hidden {...props}>
        <rect width="48" height="48" rx="11" fill="#005BFF" />
        <text
            x="24"
            y="29"
            textAnchor="middle"
            fontSize="11"
            fontWeight="900"
            fontFamily="Arial, sans-serif"
            fill="white"
        >
            OZON
        </text>
    </svg>
);

export const MarketLogoWildberries: FC<IconProps> = (props) => (
    <svg viewBox="0 0 48 48" aria-hidden {...props}>
        <defs>
            <linearGradient id="wbLogoGradient" x1="0" y1="0" x2="1" y2="1">
                <stop stopColor="#CB11AB" />
                <stop offset="1" stopColor="#7A16D5" />
            </linearGradient>
        </defs>
        <rect width="48" height="48" rx="11" fill="url(#wbLogoGradient)" />
        <path d="M11 16h5l3.2 15L23 16h4l3.8 15L34 16h5l-5.5 20h-5L25 23.8 21.5 36h-5z" fill="white" />
    </svg>
);

export const MarketLogoYandex: FC<IconProps> = (props) => (
    <svg viewBox="0 0 48 48" aria-hidden {...props}>
        <rect width="48" height="48" rx="11" fill="#FFCC00" />
        <path d="M14 12h8.2l5.1 10.2L32.6 12H41L31 29.2V37h-7.8v-7.8z" fill="#E6322B" />
        <circle cx="13" cy="34" r="3" fill="#111" />
        <circle cx="38" cy="34" r="3" fill="#111" />
    </svg>
);

// большой карандаш, используется в rows
export function PencilIcon({ className }: IconProps) {
    return (
        <svg {...base} strokeWidth={1.8} className={className} aria-hidden="true">
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
        </svg>
    );
};

// маленький карандаш используется в изменении наименования проекта и в изменении габаритов позиции
export const IconPencil: FC<IconProps> = (props) => (
    <svg {...base} {...props}>
        <path d="M5 19h3l9-9-3-3-9 9zM14.5 6.5l3 3" />
    </svg>
);

export function InfoIcon({ className }: IconProps) {
    return (
        <svg {...base} strokeWidth={1.9} className={className} aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v5" />
            <path d="M12 16.5v.01" />
        </svg>
    );
}
export function ImportIcon({ className }: IconProps) {
    return (
        <svg {...base} strokeWidth={1.9} className={className} aria-hidden="true">
            <path d="M12 3v12" />
            <polyline points="7 10 12 15 17 10" />
            <path d="M4 20h16" />
        </svg>
    );
}

export function ExportIcon({ className }: IconProps) {
    return (
        <svg {...base} strokeWidth={1.9} className={className} aria-hidden="true">
            <path d="M12 15V3" />
            <polyline points="7 8 12 3 17 8" />
            <path d="M4 20h16" />
        </svg>
    );
}

export function ArrowDownIcon({ className }: IconProps) {
    return (
        <svg {...base} strokeWidth={1.9} className={className} aria-hidden="true">
            <path d="M12 5v14" />
            <polyline points="6 13 12 19 18 13" />
        </svg>
    );
}

const PATHS = {
    check: <path d="m5 12 5 5 9-10" />,
    checkCircle: (
        <>
            <circle cx="12" cy="12" r="8.5" />
            <path d="m8.5 12 2.5 2.5 4.5-5" />
        </>
    ),
    copy: (
        <>
            <rect x="9" y="9" width="9" height="11" rx="2" />
            <path d="M15 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3" />
        </>
    ),
    clock: (
        <>
            <circle cx="12" cy="12" r="8.5" />
            <path d="M12 7.5V12l3 1.5" />
        </>
    ),
    inbox: (
        <>
            <path d="M5.5 5.5h13l1.5 7.5v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4z" />
            <path d="M4 13h4l1.5 3h5L16 13h4" />
        </>
    ),
    alert: (
        <>
            <circle cx="12" cy="12" r="8.5" />
            <path d="M12 8v5M12 16h.01" />
        </>
    ),
    chevronRight: <path d="m9 6 6 6-6 6" />,
    list: <path d="M8 7h12M8 12h12M8 17h12M4 7h.01M4 12h.01M4 17h.01" />,
    mail: (
        <>
            <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
            <path d="m4 7 8 6 8-6" />
        </>
    ),
    sort: <path d="M7 8h10M8.5 12h7M10 16h4" />,
    search: (
        <>
            <circle cx="11" cy="11" r="6.5" />
            <path d="m16 16 4 4" />
        </>
    ),
    send: <path d="M20 4 4 11l6 2.5L12.5 20 20 4Z" />,
    download: <path d="M12 4v10M8.5 10.5 12 14l3.5-3.5M5 19h14" />,
    refresh: (
        <>
            <path d="M5 12a7 7 0 1 1 2 5" />
            <path d="M5 17v-5h5" />
        </>
    ),
    close: <path d="M6 6l12 12M18 6 6 18" />,
};

export interface GlyphProps {
    name: IconName;
    size?: number;
    strokeWidth?: number;
    className?: string;
}

export function Icon({ name, size = 14, strokeWidth = 1.8, className }: GlyphProps) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
        >
            {PATHS[name]}
        </svg>
    );
}

export function LinkIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1.5 1.5M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07l1.5-1.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}

export function KebabIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
            <circle cx="8" cy="3" r="1.5" />
            <circle cx="8" cy="8" r="1.5" />
            <circle cx="8" cy="13" r="1.5" />
        </svg>
    );
}